import { render, staticRenderFns } from "./AmnioMedicalNecessity.vue?vue&type=template&id=06686eb0&"
import script from "./AmnioMedicalNecessity.vue?vue&type=script&lang=js&"
export * from "./AmnioMedicalNecessity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports